import { Button, MenuItem, Select, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  PolarAngleAxis,
  RadialBar,
  RadialBarChart,
  ResponsiveContainer,
} from "recharts";
import { CONVERTED_BY_DATE_STATS_REQUESTED } from "redux/actions";
import MonthYearSelector from "components/MonthYearSelector/MonthYearSelector";

const ConversionRate = () => {
  const convertedStats = useSelector(
    (state) => state.stats.convertedByDateStats
  );
  const colors = ["#3D88B7", "#989DE9", "#61C595", "#49B8E9", "#EDA7FE"];

  const [data, setData] = React.useState([]);
  const [selectedMonth, setSelectedMonth] = React.useState("");
  const [selectedYear, setSelectedYear] = React.useState("");

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: CONVERTED_BY_DATE_STATS_REQUESTED,
    });
  }, []);

  useEffect(() => {
    const newData = Object.entries(convertedStats)?.map(
      ([key, value], index) => ({
        name: key,
        uv: value || 0,
        fill: colors[index],
      })
    );

    setData(newData);
  }, [convertedStats]);

  useEffect(() => {
    if (selectedMonth && selectedYear) {
      const now = new Date();
      const date = new Date(`${selectedYear}-${selectedMonth}-01`);
      dispatch({
        type: CONVERTED_BY_DATE_STATS_REQUESTED,
        payload: {
          from: date,
          to: new Date(now.getFullYear(), now.getMonth() + 1, 0),
        },
      });
    }
  }, [selectedMonth, selectedYear]);

  return (
    <Box
      display={"flex"}
      justifyContent={"space-between"}
      sx={{
        padding: 2,
        border: "1px solid #ccc",
        borderRadius: 2,
      }}
    >
      <div>
        <Typography variant="h5" style={{ marginBottom: "30px" }}>
          Conversion Rate
        </Typography>

        <Stack style={{ marginBottom: "30px" }} spacing={2}>
          {Object.entries(convertedStats).length > 0 &&
            Object.entries(convertedStats)
              // .reverse()
              ?.map(([key, value], index) => {
                console.log(value);
                const reversedIndex =
                  Object.entries(convertedStats).length - 1 - index;
                return (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box
                      sx={{
                        position: "relative",
                        display: "inline-flex",
                        mr: 4,
                      }}
                    >
                      <Button
                        sx={{
                          width: "8px",
                          height: "8px",
                          minWidth: "8px",
                          borderRadius: "50%",
                          backgroundColor: colors[reversedIndex],
                          marginRight: "5px",
                          marginTop: "3px",
                        }}
                      ></Button>
                      <Typography
                        variant="caption"
                        component="div"
                        color="textSecondary"
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          marginLeft: "40px",
                        }}
                      >
                        {key}
                      </Typography>
                    </Box>
                    <Typography style={{ marginLeft: "20px" }} variant="body1">
                      {Number(value).toFixed(2)}%
                    </Typography>
                  </Box>
                );
              })}
        </Stack>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ mt: 8, fontFamily: "bold" }}
        >
          Created {new Date().toLocaleDateString()}
        </Typography>
      </div>
      <div>
        <Box sx={{ height: 300 }}>
          <MonthYearSelector
            selectedMonth={selectedMonth}
            selectedYear={selectedYear}
            onMonthChange={setSelectedMonth}
            onYearChange={setSelectedYear}
          />
          {Object.entries(data).length > 0 && (
            <ResponsiveContainer width="100%" height="70%">
              <RadialBarChart
                cx="50%"
                cy="50%"
                innerRadius="10%"
                outerRadius="80%"
                barSize={10}
                data={data}
                margin={20}
              >
                <PolarAngleAxis
                  type="number"
                  domain={[0, 100]}
                  angleAxisId={0}
                  tick={false}
                />
                <RadialBar minAngle={15} background clockWise dataKey="uv" />
              </RadialBarChart>
            </ResponsiveContainer>
          )}
          <Typography
            style={{
              marginTop: "30px",
            }}
            variant="body1"
            color="textPrimary"
          >
            As of today At {new Date().getHours()}:{new Date().getMinutes()}
          </Typography>
        </Box>
      </div>
    </Box>
  );
};

export default ConversionRate;
